import React from 'react';
import './PortfolioCarousel.css';
import DeluxeLabsImage from './images/deluxe-labs.png';
import SkylightManagerImage from './images/skylight-manager.png';
import AilensEnglishImage from './images/ailens-english.png';
import EbookstoreImage from './images/ebookstore.png';
import BookSearchEngineImage from './images/book-search-engine.png';
import SkylightCapitalImage from './images/skylight-capital.png';

const projects = [
  {
    name: 'Deluxe Labs',
    description: 'Tienda en línea para impresión 3D con gestión de inventario y pedidos.',
    image: DeluxeLabsImage,
    technologies: ['React', 'Node.js', 'MongoDB'],
    link: 'https://deluxe-labs.netlify.app/',
  },
  {
    name: "Ailen's English",
    description: 'Plataforma educativa para clases de inglés personalizadas.',
    image: AilensEnglishImage,
    technologies: ['React', 'Node.js'],
    link: 'https://ailensenglish.netlify.app/',
  },
  {
    name: 'Ebookstore',
    description: 'Tienda en línea de libros usando MEAN stack con características de CRUD.',
    image: EbookstoreImage,
    technologies: ['Angular', 'Node.js', 'MongoDB'],
    link: 'https://ebookemporium-f902e8f709be.herokuapp.com/books',
  },
  {
    name: 'Book Search Engine',
    description: 'Motor de búsqueda de libros usando la Google Books API y GraphQL.',
    image: BookSearchEngineImage,
    technologies: ['React', 'Node.js', 'GraphQL'],
    link: 'https://book-search-graphql-svk3.onrender.com/',
  },
  {
    name: 'Skylight Capital',
    description: 'Sitio informativo sobre inversiones inmobiliarias.',
    image: SkylightCapitalImage,
    technologies: ['React', 'Node.js'],
    link: 'https://skylight-capital.netlify.app/',
  },
  {
    name: 'Skylight Manager',
    description: 'Gestión inmobiliaria con visualización de proyectos y análisis.',
    image: SkylightManagerImage,
    technologies: ['React', 'Node.js', 'MongoDB'],
    link: 'https://skylightmanager-3e9e64c2b649.herokuapp.com/login',
  }
];

const PortfolioCarousel = () => {
  return (
    <section id="portfolio-carousel" className="portfolio-carousel">
      <h2 className="carousel-title">Nuestro Portafolio</h2>
      <div className="carousel">
        {projects.map((project, index) => (
          <div className="carousel-item" key={index}>
            <div className="carousel-item-content">
              <img
                src={project.image}
                alt={`Imagen del proyecto ${project.name}`}
                className="project-image"
              />
              <div className="carousel-text">
                <h3 className="project-name">{project.name}</h3>
                <p className="project-description">{project.description}</p>
                <div className="project-technologies">
                  {project.technologies.map((tech, idx) => (
                    <span className="tech-badge" key={idx}>
                      {tech}
                    </span>
                  ))}
                </div>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-link"
                >
                  Ver Proyecto
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioCarousel;
